import {Component, Input, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {ExternalStaffService} from '../../services/external-staff.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';

@Component({
  selector: 'ngx-module-external-staff',
  templateUrl: './module-external-staff.component.html',
  styleUrls: ['./module-external-staff.component.scss'],
})
export class ModuleExternalStaffComponent implements OnInit {

  @Input() externalStaff: any;
  @Input() stationId: string;
  @Input() isEdit: boolean = false;

  loading = false;

  constructor(
    private externalStaffService: ExternalStaffService,
    protected ref: NbDialogRef<ModuleExternalStaffComponent>,
  ) { }

  ngOnInit() {
  }

  close() {
    this.ref.close(false);
  }

  async createExternalStaff() {
    this.loading = true;
    const [err] = await this.externalStaffService.store(this.stationId, this.externalStaff);
    this.loading = false;
    if (err) {
      this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
      this.close();
      return;
    }
    this.alert('Proveedor Creado');
    this.ref.close(true);
  }

  async editExternalStaff() {
    this.loading = true;
    const id = this.externalStaff.id;
    delete this.externalStaff.id;
    const [err] = await this.externalStaffService.update(this.stationId, id, this.externalStaff);
    this.loading = false;
    if (err) {
      this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
      this.close();
      return;
    }
    this.alert('Proveedor Editado');
    this.ref.close(true);
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
